module.exports = __webpack_public_path__ + "static/media/add-icon.7a473f1b.svg";